import { Box as Container } from '@mui/material'
import Label from 'components/Label'
import Layout from 'layouts/Default'
import React from 'react'

const Welcome: React.FC = () => {
  return (
    <Layout>
      <Container display='flex' alignItems='center' justifyContent='center' sx={{ height: '80vh' }}>
        <Label text='Bem Vindos ao MAC' v='h4' />
      </Container>
    </Layout>
  )
}

export default Welcome
